import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BoxDetailsTableComponent } from "./box-details-table.component";

@NgModule({
  declarations: [BoxDetailsTableComponent],
  imports: [CommonModule],
  exports: [BoxDetailsTableComponent]
})
export class BoxDetailsTableModule {}
